import Navigation from '@/components/navigation/Navigation'
import AlertList from '@/components/user/UserAlerts'
import AppShell from '@/components/shell/AppShell'

export default [
	{
		path: '/:user_uid',
		meta: {
			requiredAuth: true
		},
		components: {
			default: AppShell
		},
		props: {
			default: true
		},
		children: [
			{
				path: 'alerts',
				name: 'AlertList',
				meta: {
					requiredAuth: true
				},
				components: {
					default: AlertList,
					menu: Navigation
				},
				props: {
					default: true,
					menu: true
				}
			}
		]
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/user/alerts.js